import React, { useState } from 'react';
import {
  Button, Divider, FormControl, InputLabel, MenuItem,
  Select, Stack, TextField, Typography,
} from '@mui/material';

/** Action block: collect payment method + reference, then mark the order paid. */
export default function MarkPaidAction({ busy, onSubmit }) {
  const [pay, setPay] = useState({ payment_method: 'manual', payment_reference: '' });
  return (
    <>
      <Divider sx={{ my: '14px' }} />
      <Typography variant='body2' fontWeight='700' mb='6px'>Mark paid</Typography>
      <Stack direction='row' spacing='8px' alignItems='flex-end' flexWrap='wrap'>
        <FormControl size='small' sx={{ minWidth: 160 }}>
          <InputLabel>Method</InputLabel>
          <Select
            label='Method'
            value={pay.payment_method}
            onChange={(e) => setPay({ ...pay, payment_method: e.target.value })}
          >
            <MenuItem value='manual'>Manual (cash/wire)</MenuItem>
            <MenuItem value='stripe'>Stripe</MenuItem>
            <MenuItem value='paypal'>PayPal</MenuItem>
            <MenuItem value='crypto'>Crypto</MenuItem>
          </Select>
        </FormControl>
        <TextField
          size='small'
          label='Reference'
          value={pay.payment_reference}
          onChange={(e) => setPay({ ...pay, payment_reference: e.target.value })}
          placeholder='ch_…'
          sx={{ flex: 1 }}
        />
        <Button
          variant='contained' color='success'
          disabled={busy === 'Mark paid'}
          onClick={() => onSubmit(pay)}
        >
          Mark paid
        </Button>
      </Stack>
    </>
  );
}
